import React from 'react';
import styled from 'styled-components';

import Person from './Person';
import { environment } from '../../../utils';

const Gallery = styled.section`
  display: flex;
  flex-flow: row wrap;
  justify-content: flex-start;
`;

const IMG_URL = `${environment.REACT_APP_STATIC_URL}/img/2026/toimitus/`;

const people = [
  {
    name: 'Teemu',
    role: 'frontpage.editorialTeam.editor',
    img: `${IMG_URL}Teemu.jpg`,
    mail: 'paatoimittaja@radiodiodi.fi',
  },
  {
    name: 'Santeri',
    role: 'frontpage.editorialTeam.oltermanni',
    img: `${IMG_URL}Santeri.jpg`,
    mail: 'leo@radiodiodi.fi',
  },
  {
    name: 'Julia',
    role: 'frontpage.editorialTeam.promoRep',
    img: `${IMG_URL}Julia.jpg`,
    mail: '@radiodiodi.fi',
  },
  {
    name: 'Dan',
    role: 'frontpage.editorialTeam.studio',
    img: `${IMG_URL}Dan.jpg`,
    mail: 'studio@radiodiodi.fi',
  },
  {
    name: 'Mikko',
    role: 'frontpage.editorialTeam.corporate',
    img: `${IMG_URL}Mikko.jpg`,
    mail: 'yrityssuhteet@radiodiodi.fi',
  },
  {
    name: 'Marleena',
    role: 'frontpage.editorialTeam.communications',
    img: `${IMG_URL}Marleena.jpg`,
    mail: 'viestinta@radiodiodi.fi',
  },
  {
    name: 'Janita',
    role: 'frontpage.editorialTeam.graphics',
    img: `${IMG_URL}Janita.jpg`,
    // mail: 'anni@radiodiodi.fi',
  },
  {
    name: 'Visa',
    role: 'frontpage.editorialTeam.construction',
    img: `${IMG_URL}Visa.jpg`,
    // mail: 'vili@radiodiodi.fi',
  },
  {
    name: 'Atte',
    role: 'frontpage.editorialTeam.tech',
    img: `${IMG_URL}Atte.jpg`,
    mail: 'tekniikka@radiodiodi.fi',
  },
  {
    name: 'Vinski',
    role: 'frontpage.editorialTeam.tech',
    img: `${IMG_URL}Vinski.jpg`,
    mail: 'tekniikka@radiodiodi.fi',
  },
];

const ImageGallery = () => {
  return (
    <Gallery>
      {people.map((person, index) => (
        <Person key={index} {...person} />
      ))}
    </Gallery>
  );
};

export default ImageGallery;
